import { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import timerIcon from "../assets/images/sessionTimer.svg";
import {storeLogoutToken} from "../api/userAuth";

import "../index.scss";

function Autologout(props) {
  const { duration } = props;
  const [showModal, setShowModal] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);

  useEffect(() => {
    let timer;
    if (showModal && timeLeft > 0) {
      timer = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [showModal, timeLeft]);

  useEffect(() => {
    if(timeLeft && showModal) {
      if(timeLeft == 1){
        handlelogout()
      }
    }
  }, [timeLeft, showModal])

  let timeout = null;

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  useEffect(() => {
    handleShow();
    setTimeout(60);
  }, []);

  const startTimeout = () => {
    timeout = setTimeout(() => {
      setShowModal(true);
    }, duration);
  };

  const resetTimeout = () => {
    clearTimeout(timeout);
    startTimeout();
  };

  const handlelogout = async() => {
    let userToken = JSON.parse(localStorage.getItem("userToken"));
    let response= await storeLogoutToken(userToken)
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  };

  const extendSession = () => {
    resetTimeout();
    setTimeLeft(60)
    setShowModal(false);
  };

  const formatTime = (seconds) => {
    let minutes = Math.floor(seconds / 60);
    let remainingSecons = seconds % 60;
    return `${minutes}:${remainingSecons.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    startTimeout();
    document.addEventListener("mousemove", resetTimeout);
    document.addEventListener("keydown", resetTimeout);


    return () => {
      clearTimeout(timeout);
      document.removeEventListener("mousemove", resetTimeout);
      document.removeEventListener("keydown", resetTimeout);

    };
  }, []);

  return (
    <div>
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        backdropClassName="newBackdrop"
      >
        <Modal.Body>
          <div className="text-center mt-4">
            <img src={timerIcon} alt="timer" />
          </div>
          <div
            className="mt-4 mb-3 fw-600 text-center autologout-btn"
          >
            Session about to expire!
          </div>
          <div
            className="mt-2 text-center"
            style={{ textAlign: "center", margin: "5px 10px", color: "#000" }}
          >
            Your session is about to expire in <b>{formatTime(timeLeft)}</b> due
            to inactivity. Click on the extend button to continue with the
            session or else you will be logged out automatically.
          </div>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "0 none", marginBottom: "10px" }}>
          <div className="d-flex justify-content-between w-100">
            <div>
              <Button
                variant="outline-none"
                className="ms-auto autologout-btn"
                onClick={handlelogout}
              >
                Logout
              </Button>
            </div>
            <div>
              <Button
                className="autologout-extend-btn"
                onClick={extendSession}
              >
                Extend
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Autologout;
